import { createDefaultContext } from "@imi/ui/helpers/createDefaultContext.js";
import { createContext } from "react";
import { BatchSelectionRow } from "../store/types";

export type SuggestionAlternativesDialogContextType = {
  closeDialog: () => void;
  openDialog: (props: BatchSelectionRow) => void;
};

export const SuggestionAlternativesDialogContext =
  createContext<SuggestionAlternativesDialogContextType>(
    createDefaultContext(),
  );
